import React, { useEffect, useState } from 'react'
import Footer from '../shared/footer/footer'
import Navbar from '../shared/navbar/navbar'
import 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import ProgressBar from './progressbar'
import axios from '../axios'
import { useSelector } from 'react-redux'
import { Dimmer, Loader } from 'semantic-ui-react'
import ProposalModal from './proposalModal'
import { getImage1, getTimex, url_environment } from '../config'
import { useQuery } from '../Home/search'
import { useHistory } from 'react-router'

const SendProposals = () => {
    const [showProposalModal, setShowProposalModal] = useState(false)
    const [modalData, setModalData] = useState({})
    const [t, i18n] = useTranslation("global")
    const [sentProposals, setSentProposals] = useState([])
    const [draftProposals, setDraftProposals] = useState([])
    const [loading, setLoading] = useState(false)
    const { userInfo } = useSelector(state => state.user)
    const query=useQuery()
    const history=useHistory()
    const loadData = async () => {
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        }
        try {
            setLoading(true)
            const { data } = await axios.get("/api/proposal", config)
            setDraftProposals(data.filter(x => !x.sent))
            setSentProposals(data.filter(x => x.sent))
            if (query.get("id") != null) {
                const proposal = data.find(x => x._id == query.get("id"))
                if (!proposal) {
                    return
                }
                handleProposalClick(proposal)
                query.delete("id")
                history.replace({
                    search: query.toString(),
                })
            }
        } catch (e) {
            console.log(e)
        }
        setLoading(false)
    }
    const handleProposalClick = (data) => {
        setShowProposalModal(true)
        setModalData(data)
    }
    useEffect(() => {
        loadData()
    }, [])
    if (loading) {
        return <Dimmer active inverted>
            <Loader />
        </Dimmer>
    }
    return (
        <>
            <Navbar />
            <main>

                <div css="max-width:1200px;margin:0 auto; padding:0 36px;">
                    <h1 css="text-align:center;">{t("contractmgmt.contract_management")}</h1>
                    <ProgressBar active={1} />
                    <h2 css="text-align:center;margin:2rem 0;">{t("contractmgmt.draft_proposals")}</h2>
                    <div css="max-width:1000px;margin:0 auto;">
                        <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;">
                            {draftProposals.map((item) => {
                                return (
                                    <div onClick={() => handleProposalClick(item)} css="cursor:pointer;flex:0 0 auto;width:20%;padding:9px; @media(max-width:960px){width:25%;}@media(max-width:700px){width:33.33333%;}@media(max-width:520px){width:50%;}@media(max-width:320px){width:100%;}">
                                        <div className="wrapper link">
                                            <div css="padding-bottom:80%;position:relative;">
                                                <img css="border-radius:8px;position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;" src={getImage1(item.service_image)} alt="" />
                                            </div>
                                            <div>
                                                <h3 css="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;min-width: 0;margin:0;">{item.receiver.freelancer_name}</h3>
                                                <p css="margin:0;word-break: break-all;">{item.service_name || ""}</p>
                                                <p css="margin:0;word-break: break-all;"><b>{t("contractmgmt.last_modify")}:</b>{getTimex(item.updated_at)}</p>
                                                <p css="margin:0;word-break: break-all;"><b>{t("contractmgmt.contract_id")}:</b>{item._id}</p>
                                                
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <h2 css="text-align:center;margin:2rem 0;">{t("contractmgmt.sent_proposals")}</h2>
                    <div css="max-width:1000px;margin:0 auto;">
                        <div css="display:flex;flex-wrap:wrap;justify-content:flex-start;">
                            {sentProposals.map((item) => {
                                return (
                                    <div onClick={() => handleProposalClick(item)} css="cursor:pointer;flex:0 0 auto;width:20%;padding:9px; @media(max-width:960px){width:25%;}@media(max-width:700px){width:33.33333%;}@media(max-width:520px){width:50%;}@media(max-width:320px){width:100%;}">
                                        <div className="wrapper link">
                                            <div css="padding-bottom:80%;position:relative;">
                                                <img css="border-radius:8px;position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;" src={getImage1(item.service_image)} alt="" />
                                            </div>
                                            <div>
                                                <h3 css="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;min-width: 0;margin:0;">{item.receiver.freelancer_name}</h3>
                                                <p css="margin:0;word-break: break-all;">{item.service_name || ""}</p>
                                                <p css="margin:0;word-break: break-all;"><b>{t("contractmgmt.last_modify")}:</b>{getTimex(item.updated_at)}</p>
                                                <p css="margin:0;word-break: break-all;"><b>{t("contractmgmt.contract_id")}:</b>{item._id}</p>
                                                {getApproveStatus(item.approve_status,t)}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
            {/* {showProposalModal && <h1>hello</h1>} */}
            <ProposalModal data={modalData} open={showProposalModal} close={() => setShowProposalModal(false)} update={() => loadData()} />
        </>
    )
}

export default SendProposals

export const getApproveStatus=(status,t)=>{
    switch(status){
        case "pending":
            return <div style={{ color: "red", fontWeight: "bold" }}>{t("product.pending_approval")}</div>
        case "approved":
            return <div style={{ color: "green", fontWeight: "bold" }}>{t("product.approved")}</div>
        case "rejected":
            return <div style={{ color: "red", fontWeight: "bold" }}>{t("product.rejected")}</div>
        case "not approved":
            return <div style={{ color: "red", fontWeight: "bold" }}></div>
    }
    return <div style={{ color: "red", fontWeight: "bold" }}></div>
}